<div class="formfield">
  <label class="formfield__label nes-p-0" for="employeeAmountSelect">
    {{ 'COMPANY_DATA.INPUT.EMPLOYEES.LABEL' | translate }}
  </label>
  <div class="formfield__inputContainer">
    <select class="select textInput--fullWidth"
    id="employeeAmountSelect"
      [cypress]="'employee_amount'"
      (ngModelChange)="selected.emit($event)"
      [(ngModel)]="employeeAmount">
      <option *ngFor="let segment of segments"
        [disabled]="segment.value === 0"
        [value]="segment.value"
        privacySensitive>
        {{ segment.displayText | translate }}
      </option>
    </select>


    <div *ngIf="employeeRequiredError">
      <ng-container>
        <nes-error-message>
          {{ employeeRequiredError }}
        </nes-error-message>
      </ng-container>
    </div>
  </div>
</div>
